import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IStratosMediaProps } from "./StratosMedia.props";

const ratios = {
  "1:1": "aspect-square",
  "4:3": "aspect-4/3",
  "3:2": "aspect-3/2",
  "16:9": "aspect-video",
  "21:9": "aspect-21/9",
  "3:4": "aspect-3/4",
  "2:3": "aspect-2/3",
} as const;

export const StratosMedia = ({
  aspectRatio,
  className,
  imageClassName,
  media,
  priority,
  sizes,
}: IStratosMediaProps) => {
  const Image = getComponent("Image");
  return (
    <figure
      className={cn(
        "relative overflow-hidden rounded-[20px] bg-surface-200",
        aspectRatio && ratios[aspectRatio],
        className,
      )}
    >
      <Image
        alt={media.alternateText}
        className="h-full w-full"
        height={media.height || undefined}
        imageClassName={cn(
          "h-full w-full",
          aspectRatio ? "object-cover" : "object-contain",
          imageClassName,
        )}
        priority={priority}
        sizes={sizes || media.sizes || undefined}
        src={media.defaultSrc}
        srcSet={media.srcSet || undefined}
        width={media.width || undefined}
      />
      {media.caption ? (
        <figcaption className="mt-3 font-stratos-body text-xs leading-[1.4] text-steel">
          {media.caption}
        </figcaption>
      ) : null}
    </figure>
  );
};

StratosMedia.displayName = "Content::StratosMedia";
